import React from 'react';

function Loading({ message = "Loading" }: { message?: string }) {
    return (
      <div className="w-screen h-screen flex items-center justify-center bg-ez-elevated/70 dark:bg-ez-base/80 dark:opacity-100">
        <div className="grid gap-3 text-center">
          <div className="flex items-center justify-center gap-1.5">
            <div className="w-4 h-4 rounded-full bg-gray-700 dark:bg-ez-elevated animate-BounceDelayOne"></div>
            <div className="w-4 h-4 rounded-full bg-gray-700 dark:bg-ez-elevated animate-BounceDelayTwo"></div>
            <div className="w-4 h-4 rounded-full bg-gray-700 dark:bg-ez-elevated animate-BounceDelayThree"></div>
          </div>
          <span className="text-ez-text-primary text-sm font-normal leading-snug dark:text-gray-200">
            {message}
          </span>
        </div>
      </div>
    );
  }

export default Loading;


